// extracted by mini-css-extract-plugin
module.exports = {"container":"_9cadcb71c3--container--omgHY","logo_img":"_9cadcb71c3--logo_img--EJ6iO"};